module.exports = __webpack_public_path__ + "img/graphical_upgrade_before.81e1b80.png";